<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.p1_html" className="web-rt-contains-link" />
    <email-margin [height]="18" />
    <hr />
    <email-margin [height]="18" />
    <ng-container *mailgunIf="data.detail_1">
      <email-text [contents]="data.detail_1!" presetName="paragraph" />
    </ng-container>
    <ng-container *mailgunIf="data.detail_2">
      <email-text [contents]="data.detail_2!" presetName="paragraph" />
    </ng-container>
    <ng-container *mailgunIf="data.detail_3">
      <email-text [contents]="data.detail_3!" presetName="paragraph" />
    </ng-container>
    <ng-container *mailgunIf="data.detail_3">
      <email-text [contents]="data.detail_3!" presetName="paragraph" />
    </ng-container>
    <email-margin [height]="18" />
    <hr />
    <email-margin [height]="18" />
    <email-text [contents]="data.p2_html" presetName="paragraph" className="web-rt-contains-link" />
  </ng-container>
  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
